export default {
    lang: {
        name: 'BGG Owners'
    }
}
